import { Divider } from '@mui/material';
import { useMemo } from 'react';
import { AutocompleteElement } from 'react-hook-form-mui';
import { useCountries } from '../../../../sic-lib/api/hooks/useResources';

type Props = {
    name: string;
    label: string;
    required?: boolean;
};

export function CountriesAutocompleteElement({ ...props }: Props) {
    const { data: apiData, isLoading } = useCountries();

    //put CA and US at the top of the list
    const ddlCountries = useMemo(() => {
        const countries =
            apiData?.map(country => {
                return {
                    id: country.countryCode,
                    label: country.countryName,
                };
            }) || [];

        const usEntry = countries.find(country => country.id === 'US');
        const caEntry = countries.find(country => country.id === 'CA');
        const otherCountries = countries.filter(
            country => country.id !== 'US' && country.id !== 'CA',
        );

        // Create a new array with US first, CA second, followed by the rest
        const sorted = [];
        if (usEntry) sorted.push(usEntry);
        if (caEntry) sorted.push(caEntry);
        sorted.push(...otherCountries);

        return sorted;
    }, [apiData]);

    return (
        <AutocompleteElement
            {...props}
            loading={isLoading}
            options={ddlCountries}
            matchId={true}
            autocompleteProps={{
                renderOption: (props, option) => (
                    <div key={option.id}>
                        <li {...props}>{option.label}</li>
                        {option.id === 'CA' && <Divider sx={{ mb: 1, mt: 1 }} />}
                    </div>
                ),
            }}
        />
    );
}
